import lodashGet from "lodash/get";
import { PillarTableBaseColumnCellValuePathProps } from "shared/components/pillar-table/columns/PillarTableColumn";
import { usePillarTableRowContext } from "shared/components/pillar-table/row/PillarTableRowContext";
import { DeepKeys } from "shared/types/deepkeys";
export interface PillarTableExportToExcelColumnProps<T> {
  valueProperty?: DeepKeys<T>;
  header: string;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  children?: (item: any) => string;
}

/**
 * @deprecated Each Export Column should just be defined as a regular Column.
 */
const PillarTableExportToExcelColumn = <T,>(
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  {
    valueProperty,
    cellValuePath,
  }: PillarTableExportToExcelColumnProps<T> &
    PillarTableBaseColumnCellValuePathProps,
) => {
  console.log(
    "PillarTableExportToExcelColumn is deprecated, please use PillarTable.Column instead.",
  );
  const { rowValue } = usePillarTableRowContext();
  const value = lodashGet(rowValue, (valueProperty ?? cellValuePath) as string);
  if (value) {
    return <>{value}</>;
  }
  return <></>;
};

/**
 * @deprecated Each Export Column should just be defined as a regular Column.
 */
export default PillarTableExportToExcelColumn;
